import type { PersistedAgentConfig } from '@/types/agent';

interface AgentCardProps {
	agent: PersistedAgentConfig;
	onClick: () => void;
	staggerIndex: number;
}

export const AgentCard = ({ agent, onClick, staggerIndex }: AgentCardProps) => {
	const statusColors = {
		active: { bg: '#10b981', text: 'Active' },
		paused: { bg: '#f59e0b', text: 'Paused' },
		archived: { bg: '#6b7280', text: 'Archived' },
	};

	const statusConfig = statusColors[agent.status];

	return (
		<button
			type="button"
			onClick={onClick}
			className="glass-card glass-card-hover-blue animate-agent-card-enter
				w-full cursor-pointer p-6 text-left transition-all"
			style={{
				animationDelay: `${Math.min(staggerIndex, 6) * 50}ms`,
			}}
		>
			<div className="mb-3 flex items-start justify-between">
				<h3
					style={{
						fontSize: '1.125rem',
						fontWeight: 700,
						color: 'var(--text-primary)',
						letterSpacing: '-0.01em',
					}}
				>
					{agent.name}
				</h3>
				<div className="status-pill" style={{ background: '#f3f4f6' }}>
					<div
						style={{
							width: 6,
							height: 6,
							borderRadius: '50%',
							background: statusConfig.bg,
						}}
					/>
					<span style={{ color: 'var(--text-secondary)', fontSize: '0.75rem' }}>
						{statusConfig.text}
					</span>
				</div>
			</div>

			<p
				style={{
					fontSize: '0.875rem',
					color: 'var(--text-muted)',
					lineHeight: 1.5,
					marginBottom: '0.75rem',
				}}
			>
				{agent.task || 'No task instructions provided'}
			</p>

			<div className="flex flex-wrap gap-2">
				{agent.heartbeat && (
					<div
						style={{
							padding: '4px 10px',
							borderRadius: '6px',
							background: '#f9fafb',
							border: '1px solid #e5e7eb',
							fontSize: '0.75rem',
							color: 'var(--text-secondary)',
							fontWeight: 500,
						}}
					>
						{agent.heartbeat}
					</div>
				)}
				{agent.priority && (
					<div
						style={{
							padding: '4px 10px',
							borderRadius: '6px',
							background: '#eff6ff',
							border: '1px solid #dbeafe',
							fontSize: '0.75rem',
							color: '#3b82f6',
							fontWeight: 500,
						}}
					>
						{agent.priority}
					</div>
				)}
			</div>
		</button>
	);
};
